import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';

import { Row, Col, Input } from 'reactstrap';

export const FacebookForm = ({ canal, control, errors }) => {
  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  return (
    <>
      <Row>
        <Col md="6">
          <label className="form-control-label">Nome do canal</label>
          <Controller
            as={Input}
            control={control}
            name="nome_canal"
            defaultValue={canal?.nome_canal ?? ''}
            rules={{
              required: 'nome é um campo obrigatório'
            }}
          />
          <ErrorMessage
            errors={errors}
            name="nome_canal"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>
        <Col md="6">
          <label className="form-control-label">Descrição</label>
          <Controller
            as={Input}
            control={control}
            name="descricao"
            rules={{
              required: 'descrição é um campo obrigatório'
            }}
            defaultValue={canal?.descricao ?? ''}
          />
          <ErrorMessage
            errors={errors}
            name="descricao"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>
      </Row>
      <Row>
        <Col md="6">
          <label className="form-control-label">Token Facebook</label>
          <Controller
            as={Input}
            control={control}
            name="tokenFacebook"
            rules={{
              required: 'Token Facebook é um campo obrigatório'
            }}
            defaultValue={canal?.tokenFacebook ?? ''}
          />
          <ErrorMessage
            errors={errors}
            name="tokenFacebook"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>
        <Col md="6">
          <label className="form-control-label">Facebook Access Token</label>
          <Controller
            as={Input}
            control={control}
            name="facebook_access_token"
            rules={{
              required: 'Facebook Access Token é um campo obrigatório'
            }}
            defaultValue={canal?.facebook_access_token ?? ''}
          />
          <ErrorMessage
            errors={errors}
            name="facebook_access_token"
            render={({ message }) => errorFormMessage(message)}
          />
        </Col>
      </Row>
    </>
  );
};
